import React,{useState, useEffect} from 'react';
import Headerstyles from './UnitHeader.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const UnitHeader = ({ unit }) => {
  const userId = localStorage.getItem('tenantUserId');
  const [favoriteStatus, setFavoriteStatus] = useState(null);
  
  useEffect(() => {
    const fetchFavoriteStatus = async () => {
      const res = await fetch(`${API_BASE_URL}/users/${userId}/favorites/Unit/${unit.UnitID}`);
      const data = await res.json();
      setFavoriteStatus(data.preference);
    };

    if (userId) fetchFavoriteStatus();

  }, [userId, unit.UnitID]);
  
  const handleFavoriteClick = async (preference) => {
    const method = favoriteStatus === preference ? 'DELETE' : 'POST';

    await fetch(`${API_BASE_URL}/users/${userId}/favorites`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        itemType: 'Unit',
        itemId: unit.UnitID,
        preference: method === 'DELETE' ? null : preference,
      }),
    });
	
    setFavoriteStatus(prev => (prev === preference ? null : preference));
  };

  
  return (
    <div className={Headerstyles.header}>
      <h2 className={Headerstyles.address}>{unit.BuildingAddress}</h2>
      <h3 className={Headerstyles.unitNumber}>Apt {unit.UnitNumber}</h3>
      <div className={Headerstyles.statusBadge}>Available</div>
      <div className={Headerstyles.actions}>
        <button
          className={`${Headerstyles.actionBtn} ${favoriteStatus === 'Favorite' ? Headerstyles.selected : ''}`}
          onClick={() => handleFavoriteClick('Favorite')}
        >
	     	❤️ Favorite
		</button>
        <button
          className={`${Headerstyles.actionBtn} ${favoriteStatus === 'Dislike' ? Headerstyles.selected : ''}`}
          onClick={() => handleFavoriteClick('Dislike')}
        >
          👎 Dislike
        </button>
        <button className={Headerstyles.actionBtn}>🔗 Share</button>
      </div>
    </div>
  );
};

export default UnitHeader;
